export const WECOM_PREVIEW_DUPLICATE_WINDOW_MS = 600;

export function createWeComPreviewDuplicateGuard(
  duplicateWindowMs = WECOM_PREVIEW_DUPLICATE_WINDOW_MS,
) {
  let lastTriggeredAt = Number.NEGATIVE_INFINITY;

  return (now = Date.now()): boolean => {
    const elapsed = now - lastTriggeredAt;
    const duplicate = elapsed >= 0
      && elapsed < duplicateWindowMs;

    lastTriggeredAt = now;
    return duplicate;
  };
}

export const shouldSuppressDuplicateWeComPreview = createWeComPreviewDuplicateGuard();
